import api from "./api";

export const callGetTicketsByParams = async (lottoId, ticketNumber, phone, lada) => {
    try {
        const params = new URLSearchParams();
        if (ticketNumber) {
            params.set("ticketNumber", ticketNumber);
        } else if (phone) {
            params.set("phone", phone);
            params.set("lada", lada);
        }

        return await api.get(`/participants/web/ask/tickets/lotto/${lottoId}/by?${params.toString()}`);
    } catch (error) {
        console.log("Error callGetTicketsByParams");
        return error?.response || { status: 500 };
    }
};

export const callDownloadPdfTicketsByParams = async (lottoId, ticketNumber, phone, lada, lottoNumber) => {
    try {
        const params = new URLSearchParams();
        if (ticketNumber) {
            params.set("ticketNumber", ticketNumber);
        } else if (phone) {
            params.set("phone", phone);
            params.set("lada", lada);
        }

        const response = await api.get(`/participants/web/download/pdf/tickets/lotto/${lottoId}/by?${params.toString()}`, { responseType: 'blob' });

        // VALIDACIÓN CRÍTICA: ¿Es un JSON de error disfrazado de Blob?
        if (response.data.type === 'application/json') {
            // Si el backend envió un error, lo convertimos a texto para leerlo
            const text = await response.data.text();
            const errorData = JSON.parse(text);
            return { status: response.status, error: errorData };
        }

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        const fileName = `RGF_Boletos_Sorteo_${lottoNumber}.pdf`;
        link.setAttribute('download', fileName);

        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

        return { status: 200 };

    } catch (error) {
        console.log("Error callDownloadPdfTicketsByParams");
        return error.response || { status: 500 };
    }
};

export const callGetTicketsByTicketNumberAndAction = async (lottoId, ticketNumber, action) => {
    try {
        const params = new URLSearchParams({ ticketNumber: ticketNumber });
        return await api.get(`/participants/dashboard/${action}/tickets/lotto/${lottoId}/by?${params.toString()}`);
    } catch (error) {
        console.log("Error callGetTicketsByTicketNumberAndAction");
        return error?.response || { status: 500 };
    }
};

export const callParticipantByPhone = async (lada, phone, recaptchaToken) => {
    try {
        const params = new URLSearchParams({ lada, phone, recaptchaToken });
        return await api.get(`/participants/web/by?${params.toString()}`);
    } catch (error) {
        console.log("Error callParticipantByPhone");
        return error?.response || { status: 500 };
    }
};

export const callReserveTicket = async (data) => {
    try {
        return await api.post(`/participants/web/reserve/ticket`, data);
    } catch (error) {
        console.log("Error callReserveTicket");
        return error?.response;
    }
};

export const callResetTicket = async (lottoId, ticketNumbers) => {
    try {
        return await api.put(`/participants/dashboard/reset/lotto/${lottoId}/tickets`, ticketNumbers);
    } catch (error) {
        console.log("Error callResetTicket");
        return error?.response || { status: 500 };
    }
};

export const callMarkAsPaidTicket = async (lottoId, data) => {
    try {
        return await api.put(`/participants/dashboard/mark/paid/lotto/${lottoId}/tickets`, data);
    } catch (error) {
        console.log("Error callMarkAsPaidTicket");
        return error?.response || { status: 500 };
    }
};

export const callRemovePaidTicket = async (lottoId, data) => {
    try {
        return await api.put(`/participants/dashboard/remove/paid/lotto/${lottoId}/tickets`, data);
    } catch (error) {
        console.log("Error callRemovePaidTicket");
        return error?.response || { status: 500 };
    }
};